<template>
  <div id="app">
    <router-view></router-view>
    <Dialogs />
  </div>
</template>

<script>
import Dialogs from "@/pages/console/Dialogs";
export default {
  components: { Dialogs },
};
</script>

<style lang="scss" >
body {
  margin: 0 0;
}

#app {
  font-family: Helvetica, sans-serif;
}

.el-table {
  .el-table__body-wrapper::-webkit-scrollbar {
    width: 10px; /*滚动条宽度*/
    height: 10px; /*滚动条高度*/
  }
  /*定义滚动条轨道 内阴影+圆角*/
  .el-table__body-wrapper::-webkit-scrollbar-track {
    box-shadow: 0px 1px 3px #f3f1ea inset; /*滚动条的背景区域的内阴影*/
    border-radius: 10px; /*滚动条的背景区域的圆角*/
    background-color: #ffffff; /*滚动条的背景颜色*/
  }
  /*定义滑块 内阴影+圆角*/
  .el-table__body-wrapper::-webkit-scrollbar-thumb {
    box-shadow: 0px 1px 3px #4caee7 inset; /*滚动条的内阴影*/
    border-radius: 10px; /*滚动条的圆角*/
    background-color: #66a8f3; /*滚动条的背景颜色*/
  }
}
</style>
